// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: process.env.VUE_APP_NAME, // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require('@/assets/images/logo/tobooklink_logo.svg'),
    // eslint-disable-next-line global-require
    appBlackLogoImage: require('@/assets/images/logo/tobooklink_logo_black.svg'), // Will update logo in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appShortLogo: require('@/assets/images/logo/tobooklink_icon_link.svg'),
    bookingURL: process.env.VUE_APP_STOREFRONT_URL,
    widgetURL: `${process.env.VUE_APP_WIDGET_URL}/js/app.js`,
    backendHostname: process.env.VUE_APP_BACKEND_API_HOSTNAME,
    firebaseVapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
}
